import { FORMAT_DATE_TIME_PICKER } from "contants/app.contant";
import { ConfigProvider, Col, Row } from "antd";
import dayjs from "dayjs";
import React from "react";
import helper from "helper";

function ExpandTable({ record }) {
  const renderTableValue = (value, adornment = "%", defaultValue = "0%") => {
    let result = defaultValue;
    if (value) {
      result = value + adornment;
    }
    return result;
  };
  return (
    <ConfigProvider>
      <Row
        gutter={1}
        className='rounded-t-lg border border-[#EFEFF5] border-b-0 bg-[#F9F9FB] h-[76px] text-[#6F6F7B] text-sm leading-[22px] font-semibold'
      >
        <Col className='gutter-row' span={12}>
          <Row gutter={1} className='h-full'>
            <Col
              className='gutter-row flex items-center justify-center border-r border-[#EFEFF5]'
              span={6}
            >
              <div>매체명</div>
            </Col>
            <Col
              className='gutter-row flex items-center justify-center border-r border-[#EFEFF5]'
              span={6}
            >
              <div>배포일</div>
            </Col>
            <Col
              className='gutter-row flex items-center justify-center border-r border-[#EFEFF5]'
              span={6}
            >
              <div>조회수</div>
            </Col>
            <Col className='gutter-row border-r border-[#EFEFF5]' span={6}>
              <div className='border-b border-[#EFEFF5] flex items-center justify-center h-1/2'>
                <p>유입성별</p>
              </div>
              <Row gutter={1} className='flex justify-center items-center h-1/2'>
                <Col className='gutter-row text-center' span={12}>
                  <div>남성</div>
                </Col>
                <Col className='gutter-row text-center' span={12}>
                  <div>여성</div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col className='gutter-row' span={12}>
          <Row gutter={1} className='h-full'>
            <Col className='gutter-row border-r border-[#EFEFF5]' span={16}>
              <div className='border-b border-[#EFEFF5] flex items-center justify-center h-1/2'>
                <p>유입연령</p>
              </div>
              <Row gutter={1} className='flex justify-evenly items-center h-1/2'>
                <Col className='gutter-row text-center' span={4}>
                  <div>10대</div>
                </Col>
                <Col className='gutter-row text-center' span={4}>
                  <div>20대</div>
                </Col>
                <Col className='gutter-row text-center' span={4}>
                  <div>20대</div>
                </Col>
                <Col className='gutter-row text-center' span={4}>
                  <div>40대</div>
                </Col>
                <Col className='gutter-row text-center' span={4}>
                  <div>50대</div>
                </Col>
              </Row>
            </Col>
            <Col className='gutter-row ' span={8}>
              <div className='border-b border-[#EFEFF5] flex items-center justify-center h-1/2'>
                <p>유입경로</p>
              </div>
              <Row gutter={1} className='flex justify-center items-center h-1/2'>
                <Col className='gutter-row text-center' span={8}>
                  <div>구글</div>
                </Col>
                <Col className='gutter-row text-center' span={8}>
                  <div>네이버</div>
                </Col>
                <Col className='gutter-row text-center' span={8}>
                  <div>기타</div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {record?.publisher_analytics?.length > 0 &&
        record?.publisher_analytics.map((analytics, index) => (
          <Row
            key={index}
            gutter={1}
            className='border border-[#EFEFF5] border-b-0 h-[48px] text-[#555560] text-base font-normal'
          >
            <Col className='gutter-row' span={12}>
              <Row gutter={1} className='h-full'>
                <Col
                  className='gutter-row flex items-center justify-center border-r border-[#EFEFF5] gap-2'
                  span={6}
                >
                  <div className='text-base font-normal'>{analytics?.media_name || "-"}</div>
                  <a href={analytics?.published_url} target='_blank' rel='noreferrer'>
                    <svg
                      width='17'
                      height='16'
                      viewBox='0 0 17 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      className='cursor-pointer'
                    >
                      <path
                        d='M5.66694 2.75C6.08116 2.75 6.41694 2.41421 6.41694 2C6.41694 1.58579 6.08116 1.25 5.66694 1.25V2.75ZM15.4167 11C15.4167 10.5858 15.081 10.25 14.6667 10.25C14.2525 10.25 13.9167 10.5858 13.9167 11H15.4167ZM13.5745 13.782L13.234 13.1137L13.5745 13.782ZM14.449 12.908L13.7807 12.5675L14.449 12.908ZM2.88473 12.908L2.21648 13.2485H2.21648L2.88473 12.908ZM3.75854 13.782L4.09904 13.1137L3.75854 13.782ZM3.75854 2.21799L4.09904 2.88624L3.75854 2.21799ZM2.88473 3.09204L3.55299 3.43253L2.88473 3.09204ZM13.9167 7C13.9167 7.41421 14.2525 7.75 14.6667 7.75C15.081 7.75 15.4167 7.41421 15.4167 7H13.9167ZM14.6667 2H15.4167C15.4167 1.58579 15.081 1.25 14.6667 1.25V2ZM9.66675 1.25C9.25253 1.25 8.91675 1.58579 8.91675 2C8.91675 2.41421 9.25253 2.75 9.66675 2.75V1.25ZM7.13642 8.46967C6.84352 8.76256 6.84352 9.23744 7.13642 9.53033C7.42931 9.82322 7.90418 9.82322 8.19708 9.53033L7.13642 8.46967ZM5.66694 1.25H4.86694V2.75H5.66694V1.25ZM1.91675 5.19995V10.8H3.41675V5.19995H1.91675ZM5.86694 14.75H11.4669V13.25H5.86694V14.75ZM11.4669 14.75C12.0146 14.75 12.4704 14.7506 12.8415 14.7202C13.2213 14.6892 13.5778 14.6221 13.915 14.4502L13.234 13.1137C13.1434 13.1599 13.0062 13.2018 12.7192 13.2252C12.4235 13.2494 12.0394 13.25 11.4669 13.25V14.75ZM13.9167 11C13.9167 12.1872 13.8989 12.3357 13.7807 12.5675L15.1172 13.2485C15.4351 12.6247 15.4167 12.0531 15.4167 11H13.9167ZM13.915 14.4502C14.4321 14.1868 14.8534 13.7664 15.1172 13.2485L13.7807 12.5675C13.6611 12.8024 13.4696 12.9937 13.234 13.1137L13.915 14.4502ZM1.91675 10.8C1.91675 11.3476 1.91616 11.8035 1.94649 12.1747C1.97752 12.5546 2.04463 12.9112 2.21648 13.2485L3.55299 12.5675C3.50685 12.477 3.46497 12.3397 3.44151 12.0525C3.41733 11.7566 3.41675 11.3724 3.41675 10.8H1.91675ZM5.86694 13.25C5.29453 13.25 4.9102 13.2494 4.61421 13.2252C4.32693 13.2018 4.18957 13.1599 4.09904 13.1137L3.41805 14.4502C3.75535 14.6221 4.11213 14.6892 4.49207 14.7202C4.86329 14.7506 5.31925 14.75 5.86694 14.75V13.25ZM2.21648 13.2485C2.48007 13.7659 2.90049 14.1865 3.41805 14.4502L4.09904 13.1137C3.86395 12.9939 3.67289 12.8029 3.55299 12.5675L2.21648 13.2485ZM4.86694 1.25C4.5926 1.25 4.39673 1.24992 4.26061 1.25369C4.14846 1.2568 3.98021 1.26219 3.82074 1.31416C3.71887 1.34736 3.63499 1.39338 3.56451 1.44398C3.5345 1.46553 3.51057 1.48533 3.49738 1.4964C3.49071 1.502 3.48429 1.50749 3.48074 1.51052C3.47644 1.51419 3.47415 1.51613 3.47204 1.51791C3.46736 1.52184 3.4673 1.52181 3.46538 1.52311C3.46187 1.52546 3.4481 1.53442 3.41805 1.54973L4.09904 2.88624C4.26161 2.80341 4.36158 2.72974 4.43737 2.66601C4.51678 2.59924 4.41377 2.69854 4.28554 2.74033C4.23724 2.75608 4.20628 2.75832 4.2152 2.75739C4.22342 2.75652 4.24785 2.75462 4.30214 2.75312C4.412 2.75008 4.58123 2.75 4.86694 2.75V1.25ZM3.41675 5.19995C3.41675 4.62752 3.41733 4.24333 3.44151 3.94747C3.46496 3.66037 3.50684 3.5231 3.55299 3.43253L2.21648 2.75155C2.04464 3.0888 1.97753 3.44544 1.94649 3.82531C1.91616 4.19643 1.91675 4.65228 1.91675 5.19995H3.41675ZM3.41805 1.54973C2.90041 1.81348 2.48003 2.2343 2.21648 2.75155L3.55299 3.43253C3.67293 3.19714 3.86403 3.00598 4.09904 2.88624L3.41805 1.54973ZM15.4167 7V2H13.9167V7H15.4167ZM14.6667 1.25H9.66675V2.75H14.6667V1.25ZM8.19708 9.53033L15.1971 2.53033L14.1364 1.46967L7.13642 8.46967L8.19708 9.53033Z'
                        fill='#FF6969'
                      />
                    </svg>
                  </a>
                </Col>
                <Col
                  className='gutter-row flex items-center justify-center border-r border-[#EFEFF5]'
                  span={6}
                >
                  <div className='text-base font-normal'>
                    {renderTableValue(
                      analytics?.published_at
                        ? dayjs(analytics?.published_at)
                            .locale("ko")
                            .format(FORMAT_DATE_TIME_PICKER)
                        : "",
                      "",
                      "-"
                    )}
                  </div>
                </Col>
                <Col
                  className='gutter-row flex items-center justify-center border-r border-[#EFEFF5]'
                  span={6}
                >
                  <div className='text-base font-normal'>
                    {renderTableValue(helper.numberWithCommas(analytics?.total_pv), "", "0")}
                  </div>
                </Col>
                <Col className='gutter-row border-r border-[#EFEFF5]' span={6}>
                  <Row gutter={1} className='flex justify-center items-center h-full'>
                    <Col className='gutter-row text-center text-base font-normal' span={12}>
                      <div>{renderTableValue(analytics?.gender?.male)}</div>
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={12}>
                      <div>{renderTableValue(analytics?.gender?.female)}</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col className='gutter-row' span={12}>
              <Row gutter={1} className='h-full'>
                <Col className='gutter-row border-r border-[#EFEFF5]' span={16}>
                  <Row gutter={1} className='flex justify-evenly items-center h-full'>
                    <Col className='gutter-row text-center text-base font-normal' span={4}>
                      {renderTableValue(analytics?.age?.["10"])}
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={4}>
                      {renderTableValue(analytics?.age?.["20"])}
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={4}>
                      {renderTableValue(analytics?.age?.["30"])}
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={4}>
                      {renderTableValue(analytics?.age?.["40"])}
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={4}>
                      {renderTableValue(analytics?.age?.["50"])}
                    </Col>
                  </Row>
                </Col>
                <Col className='gutter-row ' span={8}>
                  <Row gutter={1} className='flex justify-center items-center h-full'>
                    <Col className='gutter-row text-center text-base font-normal' span={8}>
                      {renderTableValue(analytics?.referrer_ratio?.google)}
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={8}>
                      {renderTableValue(analytics?.referrer_ratio?.naver)}
                    </Col>
                    <Col className='gutter-row text-center text-base font-normal' span={8}>
                      {renderTableValue(analytics?.referrer_ratio?.etc)}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        ))}
      <Row
        gutter={1}
        className='rounded-b-lg border border-[#EFEFF5] border-t-[#FFB1B1] bg-[#FFF8F8]  h-[56px] text-[#2C2C33] text-base font-medium'
      >
        <Col className='gutter-row' span={12}>
          <Row gutter={1} className='h-full'>
            <Col
              className='gutter-row flex items-center justify-center border-r border-[#FFEBEB] text-base'
              span={6}
            >
              평균
            </Col>
            <Col
              className='gutter-row flex items-center justify-center border-r border-[#FFEBEB] text-base'
              span={6}
            >
              {renderTableValue("", "", "-")}
            </Col>
            <Col
              className='gutter-row flex items-center justify-center border-r border-[#FFEBEB] text-base'
              span={6}
            >
              {renderTableValue(
                helper.numberWithCommas(record?.average_analytics?.total_pv),
                "",
                "0"
              )}
            </Col>
            <Col className='gutter-row border-r border-[#FFEBEB]' span={6}>
              <Row gutter={1} className='flex justify-center items-center h-full'>
                <Col className='gutter-row text-center text-base' span={12}>
                  {renderTableValue(record?.average_analytics?.gender?.male)}
                </Col>
                <Col className='gutter-row text-center text-base' span={12}>
                  {renderTableValue(record?.average_analytics?.gender?.female)}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col className='gutter-row' span={12}>
          <Row gutter={1} className='h-full'>
            <Col className='gutter-row border-r border-[#FFEBEB]' span={16}>
              <Row gutter={1} className='flex justify-evenly items-center h-full'>
                <Col className='gutter-row text-center text-base' span={4}>
                  {renderTableValue(record?.average_analytics?.age?.["10"])}
                </Col>
                <Col className='gutter-row text-center text-base' span={4}>
                  {renderTableValue(record?.average_analytics?.age?.["20"])}
                </Col>
                <Col className='gutter-row text-center text-base' span={4}>
                  {renderTableValue(record?.average_analytics?.age?.["30"])}
                </Col>
                <Col className='gutter-row text-center text-base' span={4}>
                  {renderTableValue(record?.average_analytics?.age?.["40"])}
                </Col>
                <Col className='gutter-row text-center text-base' span={4}>
                  {renderTableValue(record?.average_analytics?.age?.["50"])}
                </Col>
              </Row>
            </Col>
            <Col className='gutter-row ' span={8}>
              <Row gutter={1} className='flex justify-center items-center h-full'>
                <Col className='gutter-row text-center text-base' span={8}>
                  {renderTableValue(record?.average_analytics?.referrer_ratio?.google)}
                </Col>
                <Col className='gutter-row text-center text-base' span={8}>
                  {renderTableValue(record?.average_analytics?.referrer_ratio?.naver)}
                </Col>
                <Col className='gutter-row text-center text-base' span={8}>
                  {renderTableValue(record?.average_analytics?.referrer_ratio?.etc)}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </ConfigProvider>
  );
}
export default ExpandTable;
